import {ApiError, FormError} from "@devour/client";

export function isFormError(error: ApiError): error is FormError {
    return error.hasOwnProperty("formErrors");
}